module.exports = __webpack_public_path__ + "img/es.1c6f3621.svg";